/* Header interactions. Search rendering and results remain entirely in Doofinder. */
if (!customElements.get('cleancaro-header')) {
  customElements.define('cleancaro-header', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const search = this.querySelector('[data-doofinder-input]');
      // Closing Doofinder returns focus to its trigger. Typing must reopen it
      // through the existing click binding, which also reads the current query.
      const reopenSearch = (event) => {
        if (!event.isTrusted || event.isComposing || document.activeElement !== search || !search.value.trim()) return;
        search.click();
      };
      search?.addEventListener('input', reopenSearch, options);
      search?.addEventListener('compositionend', reopenSearch, options);
      const menu = this.querySelector('.cc-navigation');
      document.addEventListener('click', (event) => { if (!this.contains(event.target) && menu) menu.open = false; }, options);
      this.addEventListener('keydown', (event) => { if (event.key === 'Escape' && menu?.open) { menu.open = false; menu.querySelector('summary').focus(); } }, options);
      this.addEventListener('focusout', (event) => { if (event.relatedTarget && !this.contains(event.relatedTarget) && menu) menu.open = false; }, options);
      const refresh = () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.refreshCart(), 150); };
      ['cart:update', 'cart:updated', 'cart:change', 'cart:refresh', 'ajaxProduct:added'].forEach(name => document.addEventListener(name, refresh, options));
      window.addEventListener('pageshow', refresh, options);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); }, options);
    }
    disconnectedCallback() { this.controller?.abort(); this.request?.abort(); clearTimeout(this.timer); }
    async refreshCart(syncDrawer = false) {
      if (syncDrawer) clearTimeout(this.timer);
      this.request?.abort();
      this.request = new AbortController();
      try {
        const url = new URL(this.dataset.sectionUrl, location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { credentials: 'same-origin', signal: this.request.signal });
        if (!response.ok) throw new Error('Cart rendering failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        for (const selector of ['[data-cc-count]', '[data-cc-total]', '[data-cc-tax]']) {
          const source = page.querySelector(selector);
          const target = this.querySelector(selector);
          if (source && target) target.textContent = source.textContent;
        }
        const dialog = this.querySelector('.cc-cart-drawer dialog');
        if (dialog && (syncDrawer || !dialog.open)) {
          const source = page.querySelector('.cc-cart-drawer cart-items-component');
          const target = dialog.querySelector('cart-items-component');
          if (source && target) {
            target.replaceWith(document.importNode(source, true));
            const sourceDialog = page.querySelector('.cc-cart-drawer dialog');
            dialog.classList.toggle('cart-drawer--empty', sourceDialog.classList.contains('cart-drawer--empty'));
            dialog.setAttribute('aria-labelledby', sourceDialog.getAttribute('aria-labelledby'));
          }
        }
        return true;
      } catch (error) { if (error.name !== 'AbortError') console.debug('Cleancaro: cart refresh unavailable'); return false; }
    }
  });
}
